import { render, staticRenderFns } from "./shipping-address.vue?vue&type=template&id=d313c054"
import script from "./shipping-address.vue?vue&type=script&lang=js"
export * from "./shipping-address.vue?vue&type=script&lang=js"
import style0 from "./shipping-address.vue?vue&type=style&index=0&id=d313c054&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports